import { render, staticRenderFns } from "./SectionInfo.vue?vue&type=template&id=6d0d412b&scoped=true&"
import script from "./SectionInfo.vue?vue&type=script&lang=js&"
export * from "./SectionInfo.vue?vue&type=script&lang=js&"
import style0 from "./SectionInfo.vue?vue&type=style&index=0&id=6d0d412b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d412b",
  null
  
)

export default component.exports